import { makeStyles } from "tss-react/mui";
import { Grid } from "@mui/material";
import TaskMapSection from "../../map/TaskMapSection";
import { useMissionRoute } from "../../../../providers/MissionProvider";
import QuickViewDetails from "./common/QuickViewDetails";
import { useDevice } from "../../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%"
    }
  })
);

export default function TaskQuickView(props) {
  const { classes } = useStyles();
  const { task } = props;

  const taskPath = `salvageTasks.${task.taskIndex}`;
  const { route, routeRevision } = useMissionRoute(taskPath);
  const { slim } = useDevice();


  return (
    <Grid container className={classes.root}>
      <Grid container className={classes.root} item xs={12} spacing={2}>

        <Grid item lg={8} md={6} xs={12}>
          <TaskMapSection
            routeRevision={routeRevision}
            route={route}
            path={taskPath}
            fitScreenButton
            vehicleId={task?.execution?.vehicle?.id}
            details={!slim}
          />
        </Grid>

        <Grid item lg={4} md={6} xs={12}>
          <QuickViewDetails task={task} route={route} />
        </Grid>

      </Grid>
    </Grid>
  );
}
